import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Modal, Button, Form, Row, Col, Spinner } from 'react-bootstrap';

//actions
import { setShowCrowdStrikeDomainSettingsModal, setCrowdStrikeDomain } from '../../../../../../actions/detectionsActions/edrActions';

//help[ers
import modifyCrowdStrikeLink from '../../../../../../utils/modifyCrowdStrikeLink';

const crowdStrikeZones = [
    'us-1',
    'us-2',
    'eu-1'
];

const regex = /^[a-zA-Z0-9-]+$/;

const CrowdStrikeDomainSettings = () => {
    //redux
    const crowdStrikeDomain = useSelector(state => state.detections.edr.crowdStrikeDomain);
    const showCrowdStrikeDomainSettingsModal = useSelector(state => state.detections.edr.showCrowdStrikeDomainSettingsModal);
    const dispatch = useDispatch();

    //local
    const [selectedDomain, setSelectedDomain] = useState('us-1');
    const [customDomain, setCustomDomain] = useState('');
    const [modifiedLink, setModifiedLink] = useState('https://falcon.crowdstrike.com/investigate/search?query=....');

    const onModalHide = () => {
        dispatch(setShowCrowdStrikeDomainSettingsModal(false));
    };

    useEffect(() => {
        if (selectedDomain === 'other') {
            if (customDomain) {
                let url = modifyCrowdStrikeLink({ domain: customDomain });
                setModifiedLink(url);
            } else {
                let url = modifyCrowdStrikeLink({ domain: 'us-1' });
                setModifiedLink(url);
            }
        } else {
            let url = modifyCrowdStrikeLink({ domain: selectedDomain });
            setModifiedLink(url);
        }
    }, [selectedDomain, customDomain]);

    const onRadioSelect = (domain) => {
        if (domain?.toLowerCase) setSelectedDomain(domain.toLowerCase());
    };

    const onSaveClick = () => {
        if (selectedDomain === 'other' && customDomain && customDomain.match(regex)) {
            // Save the custom domain
            dispatch(setCrowdStrikeDomain(customDomain));
        } else {
            // Save the selected domain
            if (selectedDomain !== 'other') dispatch(setCrowdStrikeDomain(selectedDomain));
        }
        onModalHide();
    };

    return (
        <Modal show={showCrowdStrikeDomainSettingsModal} onHide={onModalHide} centered className="modal-primary" dialogClassName="payment-modal">
            <Modal.Header>
            </Modal.Header>

            <Modal.Body style={{ minHeight: 500 }}>
                <div className="p-3">

                    <div className="mb-2">
                        <h3 className="m-0 p-0">Please select your CrowdStrike environment zone</h3>
                    </div>

                    <Row className='mt-5'>
                        <Col md={12}>
                            <Form.Group>
                                {/* <Form.Label>Default select</Form.Label> */}
                                {
                                    crowdStrikeZones.map((zone, index) => {
                                        return (
                                            <Form.Check
                                                className='mb-2'
                                                custom
                                                // inline
                                                type="radio"
                                                label={zone}
                                                name="formHorizontalRadios"
                                                id={`formHorizontalRadios${index + 1}`}
                                                key={index}
                                                checked={selectedDomain === zone ? true : false}
                                                onChange={() => onRadioSelect(zone)}
                                            />
                                        );
                                    })
                                }
                                <Form.Check
                                    className='mb-2'
                                    custom
                                    // inline
                                    type="radio"
                                    label="other"
                                    name="formHorizontalRadios-other"
                                    id="formHorizontalRadios-other"

                                    checked={selectedDomain === 'other' ? true : false}
                                    onChange={() => setSelectedDomain('other')}
                                />

                            </Form.Group>
                        </Col>
                        <Col>
                            {/* <p className="m-0 p-0 mt-2">First name</p> */}
                            {selectedDomain === 'other' && <Form.Group>
                                <Form.Control type="text" value={customDomain} onChange={e => {
                                    // Get the input value
                                    let value = e.target.value;

                                    // Remove any character that is not a letter, number, or hyphen
                                    value = value.replace(/[^a-zA-Z0-9-]/g, '');

                                    // Set the cleaned value back to the input
                                    e.target.value = value;
                                    setCustomDomain(value);
                                }} />
                            </Form.Group>}
                            {/* <Form.Control className='text-white' value={customDomain} onChange={e => setCustomDomain(e.target.value)} /> */}
                        </Col>
                        {/* <Col>
                          <p className="m-0 p-0 mt-2">Last name</p>
                          <Form.Control value={lastName} onChange={e => setLastName(e.target.value)} disabled={currentUser._id ? true : false} />
                      </Col>
                      <Col>
                          <p className="m-0 p-0 mt-2">Company (optional)</p>
                          <Form.Control value={company} onChange={e => setCompany(e.target.value)} disabled={currentUser._id ? true : false} />
                      </Col> */}
                    </Row>

                    <div className="link-area">
                        {modifiedLink.split('.').map((part, index) => {
                            return (
                                <>
                                    <span key={index} className={[...crowdStrikeZones, selectedDomain, customDomain].includes(part) ? 'text-blue' : ''}>{part}</span>
                                    {index !== modifiedLink.split('.').length - 1 && <span>.</span>}
                                </>
                            );
                        })}
                    </div>

                    <div className="d-flex justify-content-center mt-4 ">
                        <Button onClick={onSaveClick}>Save</Button>
                    </div>
                </div>
            </Modal.Body>
        </Modal >

    );
};

/**
US-1 “api.crowdstrike.com”

US-2 “api.us-2.crowdstrike.com”

US-GOV-1 “api.laggar.gcw.crowdstrike.com”

EU-1 “api.eu-1.crowdstrike.com”
*/

export default CrowdStrikeDomainSettings;